export class Revenue {
    id: number;
    name: string;
    count: number;
    totalRevenue: number;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/Revenue.ts